import { MicrositeListType } from '../../enums/index';

export const micrositeListTypeMap = [
    { type: MicrositeListType.All, url: 'all', name: 'All' },
    { type: MicrositeListType.PendingPatient, url: 'pending-patient', name: 'Pending Patient' },
    { type: MicrositeListType.PendingConfirmation, url: 'pending-confirmation', name: 'Pending Confirmation' },
    { type: MicrositeListType.PendingCoach, url: 'pending-custom-site-coach', name: 'Pending Coach Approval' },
    { type: MicrositeListType.PendingCenter, url: 'pending-center', name: 'Pending Center' },
    { type: MicrositeListType.PendingNkr, url: 'pending-nkr', name: 'Pending NKR' },
    { type: MicrositeListType.ActiveStarterSites, url: 'active-starter-sites', name: 'Active Starter Sites' },
    { type: MicrositeListType.ActiveCustomSites, url: 'active-custom-sites', name: 'Active Custom Sites' },
    { type: MicrositeListType.Stagnant, url: 'stagnant-sites', name: 'Stagnant Sites' },
    { type: MicrositeListType.Disapproved, url: 'disapproved', name: 'Disapproved' },
    { type: MicrositeListType.Inactive, url: 'inactive', name: 'Inactive' },
    { type: MicrositeListType.PendingCards, url: 'pending-cards', name: 'Pending Cards' },
    { type: MicrositeListType.CoachWaitList, url: 'coach-wait-list', name: 'Coach Wait List' },
    { type: MicrositeListType.PostTransplantSites, url: 'active-post-txp-sites', name: 'Active Post Txp Sites' }
]